// src/utils/userEvents.js
export const PP_USER_READY_EVENT = "pp_user_ready";

export function dispatchUserReadyEvent() {
  if (typeof window === "undefined" || typeof window.dispatchEvent !== "function") {
    return;
  }
  try {
    window.dispatchEvent(new Event(PP_USER_READY_EVENT));
  } catch (err) {
    try {
      const fallbackEvent = document.createEvent("Event");
      fallbackEvent.initEvent(PP_USER_READY_EVENT, true, true);
      window.dispatchEvent(fallbackEvent);
    } catch {
      // ignore dispatch failures
    }
  }
}
